import { TidewaysContext } from '../app/context'

export const planSupportsTracepoints = (tidewaysContext: TidewaysContext) => tidewaysContext.application.license.tracepoints
export const allowedDurationsForTracepoints = (tidewaysContext: TidewaysContext) =>
    getRestrictions(tidewaysContext.application.license.license).durations
export const maxConcurrentTracepoints = (tidewaysContext: TidewaysContext) =>
    getRestrictions(tidewaysContext.application.license.license).maxConcurrent

const getRestrictions = (license: string): { durations: number[]; maxConcurrent: number } =>
    license in tracepointPlanRestrictions ? tracepointPlanRestrictions[license] : { durations: [], maxConcurrent: 0 }

const tracepointPlanRestrictions = {
    request: { durations: [15, 60], maxConcurrent: 1 },
    starter: { durations: [15, 60, 120, 180, 360, 720, 1440], maxConcurrent: 1 },
    basic: { durations: [15, 60, 120, 180, 360, 720, 1440], maxConcurrent: 1 },
    standard: { durations: [15, 60, 120, 180, 360, 720, 1440], maxConcurrent: 5 },
    pro: { durations: [15, 60, 120, 180, 360, 720, 1440], maxConcurrent: 20 },
}
